import { render, staticRenderFns } from "./WithdrawAudit.vue?vue&type=template&id=504cf8db&"
import script from "./WithdrawAudit.vue?vue&type=script&lang=ts&"
export * from "./WithdrawAudit.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawAudit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WithdrawAudit.vue"
export default component.exports